// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__2991D","button":"styles_button__24ec9"};